<template>
  <div class="c-tdl-device-detail">
    <div class="c-tdl-device-detail__page-header">
      <div>
        <h2 class="c-tdl-device-detail__title">设备详情</h2>
        <div class="flex q-mt-sm">
          <div class="c-tdl-device-detail__subtitle">设备SN：{{ snCode }}</div>
          <div class="c-tdl-device-detail__subtitle q-ml-lg">设备名称：{{ deviceDetail?.name }}</div>
        </div>
      </div>
    </div>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">实时状态</span>
      </div>
      <div class="c-tdl-device-detail__status-grid">
        <div v-for="item in statusCards" :key="item.label" class="c-tdl-device-detail__status-card">
          <div class="c-tdl-device-detail__status-label">{{ item.label }}</div>
          <div
            class="c-tdl-device-detail__status-value"
            :class="`c-tdl-device-detail__status-value--${item.theme} v-${item.value}`"
          >
            {{ item.content }}
          </div>
        </div>
      </div>
    </section>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">当前配送任务</span>
      </div>
      <div v-if="deliveryTask.orderCount" class="c-tdl-device-detail__task-card">
        <div class="c-tdl-device-detail__task-top">
          <el-tag v-if="deliveryTask.statusName" :type="deliveryTask.tagType" effect="dark">
            {{ deliveryTask.statusName }}
          </el-tag>
          <span class="c-tdl-device-detail__task-order">波次号：{{ deliveryTask.thirdPartyTaskNo }}</span>
        </div>
        <div class="c-tdl-device-detail__task-row">
          本单需配送 {{ deliveryTask.roomCount }} 户、共 {{ deliveryTask.orderCount }} 包裹
        </div>
        <div class="c-tdl-device-detail__task-row">
          当前已完成 {{ deliveryTask.deliveriedRoomCount }} 户、{{ deliveryTask.deliveriedOrderCount }} 件包裹配送
        </div>
        <div class="c-tdl-device-detail__task-progress">
          <el-progress v-if="deliveryTask.progress !== null" :percentage="deliveryTask.progress" :stroke-width="12" />
        </div>
        <!-- <div class="c-tdl-device-detail__task-row">路线：{{ deliveryTask.route }}</div> -->
        <div class="c-tdl-device-detail__task-row">开始时间：{{ deliveryTask.startTime }}</div>
      </div>
      <div v-else>当前设备暂无配送任务</div>
    </section>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">格口状态</span>
      </div>
      <div class="c-tdl-device-detail__cell-grid">
        <div
          v-for="cell in displayedCellStatusList"
          :key="cell.cellNo"
          class="c-tdl-device-detail__cell-card"
          :class="`c-tdl-device-detail__cell-card--${getCellStatusTheme(cell.orderStatus)}`"
        >
          <div class="c-tdl-device-detail__cell-no">{{ cell.cellNo }}</div>
          <div
            class="c-tdl-device-detail__cell-status"
            :class="`c-tdl-device-detail__cell-status--${getCellStatusTheme(cell.orderStatus)}`"
          >
            {{ cell.orderStatusName }}
          </div>
        </div>
      </div>
    </section>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">报警信息</span>
      </div>
      <div v-if="alarmList?.length" class="c-tdl-device-detail__list">
        <div v-for="(alarm, index) in alarmList" :key="`${alarm.time}-${index}`" class="c-tdl-device-detail__list-item">
          <div class="c-tdl-device-detail__list-main">
            <span class="c-tdl-device-detail__level-tag">{{ alarm.alarmLevelName }}</span>
            <span class="c-tdl-device-detail__list-content">{{ alarm.alarmMessage }}</span>
          </div>
          <div class="c-tdl-device-detail__list-time">{{ alarm.alarmTime }}</div>
        </div>
      </div>
      <div v-else>当前设备暂无报警信息</div>
    </section>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">操作日志</span>
      </div>
      <div v-if="operationLogs?.length" class="c-tdl-device-detail__list">
        <div
          v-for="(log, index) in operationLogs"
          :key="`${log.gmtCreate}-${index}`"
          class="c-tdl-device-detail__list-item c-tdl-device-detail__list-item--log"
        >
          <div class="c-tdl-device-detail__log-main">
            <div class="c-tdl-device-detail__list-content">{{ log.content }}</div>
            <div class="c-tdl-device-detail__log-meta">操作人：{{ log.operatorName }}</div>
          </div>
          <div class="c-tdl-device-detail__list-time">{{ log.gmtCreate }}</div>
        </div>
      </div>
      <div v-else>当前设备暂无操作日志</div>
    </section>

    <section class="c-tdl-device-detail__section-card">
      <div class="c-tdl-device-detail__section-header">
        <span class="c-tdl-device-detail__section-title">组成部件</span>
      </div>
      <div class="c-tdl-device-detail__parts-table-wrap">
        <table class="c-tdl-device-detail__parts-table">
          <thead>
            <tr>
              <th>部件类型</th>
              <th>部件 SN</th>
              <th>型号</th>
              <th>供货厂商</th>
              <th>状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="part in partsList" :key="part.type">
              <td>{{ part.typeName }}</td>
              <td>{{ part.sn }}</td>
              <td>{{ part.model }}</td>
              <td>{{ part.supplier }}</td>
              <td>{{ part.statusName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useApiRequest, useCurrentAppInstance, computed, onMounted, ref, onActivated, reactive } from '@zto/zpage'

import { normalizeOperationLogs } from './logs'
import { normalizeRealtimeStatusCards } from './status'
import { normalizeAffiliatedParts } from './parts'
import { commonOptions, TdlDeviceOrderStatus } from '@/config'
import { getCommonOptionLabel } from '@/utils'

const apiRequest = useApiRequest()
const app = useCurrentAppInstance()
const route = app.useRoute()

const snCode = computed(() => String(route.query?.snCode || ''))

const defaultStatusCards: Array<any> = [
  { label: '电量', value: '', theme: 'power' },
  { label: '网络', value: '', theme: 'network' },
  { label: '是否在基站', value: '', theme: 'runInBase' }
] as const

const deviceDetail = ref<any>({})

const statusCards = ref(defaultStatusCards)

const alarmList = ref<any[]>([])

const deliveryTask = reactive<any>({
  tagType: 'info',
  status: '',
  statusName: '',
  waveNo: '',
  thirdPartyTaskNo: '',
  roomCount: '',
  orderCount: '',
  deliveriedRoomCount: '',
  deliveriedOrderCount: '',
  progress: null as number | null,
  route: '',
  startTime: '',
  orderList: [] as any[]
})

const defaultCellStatusList: Array<{ cellNo: string; status: string }> = []
const cellStatusList = ref(defaultCellStatusList)

const defaultOperationLogs: Array<{ content: string; operatorName: string; gmtCreate: string }> = []
const operationLogs = ref(defaultOperationLogs)

const defaultPartsList: Array<any> = []
const partsList = ref(defaultPartsList)
const operationLogModule = 'DEVICE_RUN'
const operationLogBizType = ''

const displayedCellStatusList = computed(() => {
  const waveOrderList = deliveryTask.orderList || []

  const statusList = (cellStatusList.value || []).map(it => {
    const orderList = waveOrderList.filter((order: any) => order.gridCompartmentCode === it.cellNo)
    const loadedOrderList = orderList.filter((order: any) => order.orderStatus === TdlDeviceOrderStatus.ALREADY_LOADED)
    const deliveriedOrderList = orderList.filter((order: any) => order.orderStatus === TdlDeviceOrderStatus.DELIVERED)
    const waitingOrderList = orderList.filter((order: any) => order.orderStatus === TdlDeviceOrderStatus.WAITING)

    let orderStatus = ''
    let orderStatusName = ''

    if (!orderList.length) {
      orderStatus = 'IDEL'
      orderStatusName = '未装货'
    } else if (orderList.length === deliveriedOrderList.length) {
      orderStatus = 'DELIVERIED'
      orderStatusName = '已送达' // 全部已送达
    } else if (orderList.length === waitingOrderList.length) {
      orderStatus = 'WAITING'
      orderStatusName = '待配送' // 全部待配送
    } else if (orderList.length === loadedOrderList.length) {
      orderStatus = 'LOADING'
      orderStatusName = '装载中'
    } else if (orderList.length > deliveriedOrderList.length) {
      orderStatus = 'DELIVERIING'
      orderStatusName = '配送中'
    }

    return { ...it, orderStatus, orderStatusName }
  })

  return statusList
})

const getCellStatusTheme = (status: string) => {
  if (['DELIVERIED'].includes(status)) return 'success'
  if (['WAITING'].includes(status)) return 'warning'
  if (['DELIVERIING', 'LOADING'].includes(status)) return 'primary'

  return 'muted'
}

// 查询设备详情
const getDeviceDetail = async () => {
  if (!snCode) return
  const res = await app.request({
    api: '/sys/admin/device/device-list/detail',
    params: { snCode: snCode.value },
    isSilent: true
  })

  deviceDetail.value = res
}

const getRealtimeStatus = async () => {
  if (!snCode.value) {
    statusCards.value = defaultStatusCards
    return
  }

  try {
    const res = await apiRequest({
      action: '/sys/admin/device/device-list/detail',
      params: {
        snCode: snCode.value
      },
      isSilent: true
    })

    statusCards.value = normalizeRealtimeStatusCards(res, defaultStatusCards)
  } catch (error) {
    statusCards.value = defaultStatusCards
  }
}

const getCellStatusList = async () => {
  if (!snCode.value) {
    cellStatusList.value = defaultCellStatusList
    return
  }

  try {
    const res = await apiRequest({
      action: '/sys/admin/device/device-list/grid-status/list',
      params: {
        snCode: snCode.value
      }
    })

    const list = res?.list || res?.result?.list || []

    cellStatusList.value = list.length
      ? list.map((item: any) => ({
          cellNo: item?.gridCompartmentCode || '',
          status: item?.gridCompartmentTaskStatus || ''
        }))
      : defaultCellStatusList
  } catch (error) {
    cellStatusList.value = defaultCellStatusList
  }
}

const getOperationLogs = async () => {
  if (!snCode.value) {
    operationLogs.value = defaultOperationLogs
    return
  }

  try {
    const res = await apiRequest({
      action: '/sys/admin/sys-config/queryOptLogList',
      params: {
        snCode: snCode.value,
        module: operationLogModule,
        bizType: operationLogBizType,
        pageIndex: 1,
        pageSize: 10
      }
    })

    operationLogs.value = normalizeOperationLogs(res, defaultOperationLogs)
  } catch (error) {
    operationLogs.value = defaultOperationLogs
  }
}

const getAffiliatedParts = async () => {
  if (!snCode.value) {
    partsList.value = defaultPartsList
    return
  }

  try {
    const res = await apiRequest({
      action: '/sys/admin/device/device-list/affiliated/list',
      params: {
        snCode: snCode.value
      }
    })

    partsList.value = normalizeAffiliatedParts(res, defaultPartsList)
  } catch (error) {
    partsList.value = defaultPartsList
  }
}

const getLatestDeliveryTask = async () => {
  const res = await apiRequest({
    action: '/sys/admin/device/device-list/queryLatestDeliveryTask',
    params: { snCode: snCode.value },
    isSilent: true
  })

  if (!res) return

  deliveryTask.thirdPartyTaskNo = res.waveInfo?.thirdPartyTaskNo || ''
  deliveryTask.roomCount = res.roomCount
  deliveryTask.orderCount = res.orderCount
  deliveryTask.deliveriedRoomCount = res.deliveriedRoomCount
  deliveryTask.deliveriedOrderCount = res.deliveriedOrderCount
  deliveryTask.progress = Number(((res.deliveriedOrderCount / (res.orderCount || 0)) * 100).toFixed(2))
  deliveryTask.startTime = res.waveInfo?.startTime || ''
  deliveryTask.orderList = res.orderList || []

  deliveryTask.status = 'delivering'
  deliveryTask.statusName = '配送执行中'
  deliveryTask.tagType = 'warning'

  if (res.orderCount === res.deliveriedOrderCount) {
    deliveryTask.status = 'completed'
    deliveryTask.statusName = '配送已完成'
    deliveryTask.tagType = 'success'
  }
}

const getAlarmList = async () => {
  const res = await apiRequest({
    action: '/sys/admin/alarm/page',
    params: { pageIndex: 1, pageSize: 5, snCode: snCode.value },
    isSilent: true
  })

  if (!res) return

  alarmList.value = (res?.data || []).map((it: any) => {
    const alarmLevelName = getCommonOptionLabel(commonOptions.tdlAlarmLevel, it.alarmLevel)
    return { ...it, alarmLevelName }
  })
}

const initData = () => {
  getDeviceDetail()
  getRealtimeStatus()
  getCellStatusList()
  getOperationLogs()
  getAffiliatedParts()
  getLatestDeliveryTask()
  getAlarmList()
}

onMounted(() => {
  initData()
})

onActivated(() => {
  initData()
})
</script>

<style scoped lang="scss">
.c-tdl-device-detail {
  min-height: 100%;
  padding: 16px;
  background: #f5f7fb;

  &__page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #1f2a37;
  }

  &__subtitle {
    font-size: 13px;
    color: #7b8794;
  }

  &__section-card {
    margin-bottom: 16px;
    padding: 20px;
    background: #fff;
    border: 1px solid #edf1f7;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(31, 42, 55, 0.05);
  }

  &__section-header {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__section-title {
    position: relative;
    padding-left: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #1f2a37;

    &::before {
      position: absolute;
      top: 2px;
      left: 0;
      width: 4px;
      height: 18px;
      background: linear-gradient(180deg, #409eff 0%, #74b9ff 100%);
      border-radius: 999px;
      content: '';
    }
  }

  &__status-grid {
    display: flex;
    gap: 16px;
  }

  &__status-card {
    flex: 1;
    padding: 20px 24px;
    background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
    border: 1px solid #e8f1ff;
    border-radius: 14px;
  }

  &__status-label {
    margin-bottom: 12px;
    font-size: 13px;
    color: #7b8794;
  }

  &__status-value {
    font-size: 36px;
    font-weight: 700;
    line-height: 1;
    color: #7b8794;

    &--power {
      &.v-ON {
        color: #2f80ed;
      }
    }

    &--network {
      &.v-ONLINE {
        color: #27ae60;
      }
    }

    &--runInBase {
      &.v-1 {
        color: #27ae60;
      }
    }
  }

  &__task-card {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__task-top {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  &__task-order {
    font-size: 15px;
    font-weight: 600;
    color: #1f2a37;
  }

  &__task-row {
    font-size: 14px;
    color: #4a5568;
    line-height: 22px;
  }

  &__task-progress {
    padding-right: 12px;
  }

  &__cell-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    gap: 12px;
  }

  &__cell-card {
    padding: 18px 12px;
    text-align: center;
    background: #f8fafc;
    border: 1px solid #e8edf3;
    border-radius: 12px;

    &--success {
      background: #effbf3;
      border-color: #b7ebc6;
    }

    &--warning {
      background: #fdf6ec;
      border-color: #faecd8;
    }

    &--primary {
      background: #eef5ff;
      border-color: #b6d4fe;
    }

    &--muted {
      background: #f6f8fb;
      border-color: #e4e7ec;
    }
  }

  &__cell-no {
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
    color: #1f2a37;
  }

  &__cell-status {
    font-size: 13px;
    color: #5b6573;

    &--DELIVERIED {
      color: #1f9d55;
    }

    &--DELIVERIING {
      color: #2f80ed;
    }

    &--WAITING {
      color: #667085;
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 14px 0;
    border-bottom: 1px solid #edf1f7;

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &__list-item--log {
    align-items: flex-start;
  }

  &__list-main,
  &__log-main {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
  }

  &__log-main {
    align-items: flex-start;
    flex-direction: column;
    gap: 6px;
  }

  &__level-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 30px;
    height: 24px;
    padding: 0 10px;
    font-size: 12px;
    color: #d9485f;
    background: #fff1f3;
    border-radius: 999px;
  }

  &__list-content {
    min-width: 0;
    font-size: 14px;
    color: #1f2a37;
    line-height: 22px;
  }

  &__log-meta {
    font-size: 13px;
    color: #7b8794;
  }

  &__list-time {
    flex-shrink: 0;
    font-size: 13px;
    color: #98a2b3;
  }

  &__parts-table-wrap {
    overflow-x: auto;
  }

  &__parts-table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    th,
    td {
      padding: 14px 16px;
      font-size: 14px;
      text-align: left;
      border-bottom: 1px solid #edf1f7;
    }

    th {
      font-weight: 600;
      color: #475467;
      background: #f8fafc;
    }

    td {
      color: #1f2a37;
    }

    tbody tr:last-child td {
      border-bottom: none;
    }
  }
}

@media (max-width: 768px) {
  .c-tdl-device-detail {
    &__status-grid {
      grid-template-columns: 1fr;
    }

    &__list-item {
      align-items: flex-start;
      flex-direction: column;
    }

    &__list-time {
      padding-left: 60px;
    }
  }
}
</style>
